// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"7ed21088","612":"4b4ce4f6","810":"05259469","903":"751f97b5","916":"81445cc5"}[chunkId] + ".chunk.js";
};